import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ApiErrorView from './ApiErrorView';
import { parseApiError } from './parseApiError';

class ErrorPage extends Component {
  render() {
    const { children, error, entity } = this.props;
    const parsed = parseApiError(error, entity);

    if (!parsed.hasError) {
      return children || null;
    }

    if (!children) {
      return <ApiErrorView parsed={parsed} entity={entity} variant="page" />;
    }

    return (
      <React.Fragment>
        <ApiErrorView parsed={parsed} entity={entity} variant="banner" />
        {children}
      </React.Fragment>
    );
  }
}

ErrorPage.defaultProps = {
  error: null,
  children: null
};

ErrorPage.propTypes = {
  entity: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default ErrorPage;
